export default from './Panel'


// WEBPACK FOOTER //
// ./app/components/Panel/index.js